<div style="position: fixed; top:0; z-index: 11; left:0; height:100%; width:100%; background: #222c;">
</div>


<div style="z-index: 12; width: 90%; height: 90vh;" class="centered scrollable-vertical">
    <ion-card>
        <ion-button (click)="clickMerge()">
            Merge
        </ion-button>
        <div>Scroll to see the merging person details</div>
        <ion-icon color='danger' name="close-circle" class='font2 floatRight floatingCloseAttachment cursorpoint'
            (click)='closePopup.emit()'></ion-icon>
        <ion-row>

            <ion-col size="12" sizeMd="5.5" class="padding0" *ngIf="merge_editable.user">
                <span class="bold font1_5">Original</span>
                <ion-card>
                    <ion-row>

                        <ion-col size="4" sizeMd="4" class="borderMedium">
                            Gender *
                        </ion-col>
                        <ion-col size="4" sizeMd="4" class="borderMedium">MALE

                            <ion-icon name="man" class="font2" color="tertiary"
                                *ngIf="merge_editable.user.gender=='MALE'"></ion-icon>
                            <ion-icon name="man-outline" class="font2" color="medium"
                                *ngIf="merge_editable.user.gender!='MALE'"></ion-icon>

                        </ion-col>
                        <ion-col size="4" sizeMd="4" class="borderMedium">FEMALE
                            <ion-icon name="woman" class="font2" color="danger"
                                *ngIf="merge_editable.user.gender!='MALE'"></ion-icon>
                            <ion-icon name="woman-outline" class="font2" color="medium"
                                *ngIf="merge_editable.user.gender=='MALE'"></ion-icon>
                        </ion-col>
                        <ion-col size="12" class="padding4"> </ion-col>
                        <ion-col size="4" sizeMd="4" class="borderMedium">
                            Marital Status *
                        </ion-col>
                        <ion-col size="4" sizeMd="4" (click)="merge_editable.user.user_pd.marital='Married'"
                            class="borderMedium">Married

                            <ion-badge class="font0_8" color="tertiary"
                                *ngIf="merge_editable.user.user_pd.marital=='Married'">M</ion-badge>
                            <ion-badge class="font0_8" color="medium"
                                *ngIf="merge_editable.user.user_pd.marital!='Married'">M</ion-badge>

                        </ion-col>
                        <ion-col size="4" sizeMd="4" (click)="merge_editable.user.user_pd.marital='UnMarried'"
                            class="borderMedium">UnMarried
                            <ion-badge class="font0_8" color="medium"
                                *ngIf="merge_editable.user.user_pd.marital!='UnMarried'">S</ion-badge>
                            <ion-badge class="font0_8" color="danger"
                                *ngIf="merge_editable.user.user_pd.marital=='UnMarried'">S</ion-badge>
                        </ion-col>
                        <ion-col size="12" class="padding4"> </ion-col>
                        <ion-col size="6" sizeMd="4">
                            <app-a-input [label]="'Name'" [validations]="['mandatory',toastService.checkValidation]"
                                [validationObject]="merge_editable.user"
                                [(variable)]="merge_editable.user.name"></app-a-input>
                            <!-- <app-a-input [label]="'Name'" [(variable)]="merge_editable.user.name"></app-a-input> -->
                        </ion-col>

                        <ion-col size="6" sizeMd="4">
                            <app-a-input [label]="'SurName'" [(variable)]="merge_editable.user.last_name"></app-a-input>
                        </ion-col>

                        <!-- <ion-col size="12" sizeMd="4" class="padding4">
            <app-a-input [label]="'पिता का Name'" [(variable)]="merge_editable.user.fatherOrHusband"></app-a-input>
        </ion-col> -->
                        <ion-col size="8" sizeMd="4" class="padding4">
                            <app-a-input [label]="'Mobile'"
                                [(variable)]="merge_editable.user.user_pd.mobile"></app-a-input>
                        </ion-col>


                        <ion-col size="12" sizeMd="4" class="padding4">
                            <app-a-select [label]="'Education'" [(variable)]="merge_editable.user.user_pd.education"
                                [objectList]="utilityService.educationList"></app-a-select>
                        </ion-col>

                        <ion-col size="12" sizeMd="4" class="padding4">
                            <app-a-select [label]="'Profession'" [(variable)]="merge_editable.user.user_pd.profession"
                                [objectList]="utilityService.professionList"></app-a-select>
                        </ion-col>

                        <ion-col size="12" sizeMd="4" class="padding4">
                            <app-a-select [label]="'Occupation'" [(variable)]="merge_editable.user.user_pd.occupation"
                                [objectList]="utilityService.occupationList"></app-a-select>
                        </ion-col>

                        <ion-col size="12" sizeMd="4" class="padding4">
                            <app-a-input [label]="'Area/Pincode'" [(variable)]="merge_editable.user.user_pd.pincode"
                                (onType)="searchPincode($event)"></app-a-input>
                            <ion-card *ngIf="showPincodeOption1" class="scrollable margin0" style="height: 30vh;">
                                <div *ngFor="let pin of filteredPinCode">
                                    <div class="padding5" (click)="setAddress(pin,'current_address')">{{pin}}</div>
                                    <div style="width: 100%; height:1px; background-color: black; color: black;"> </div>
                                </div>
                            </ion-card>
                        </ion-col>

                        <ion-col size="12" sizeMd="4" class="padding4">
                            <app-a-input [label]="'Address'"
                                [(variable)]="merge_editable.user.user_pd.permanent_address"></app-a-input>
                        </ion-col>
                        <ion-col size="12" sizeMd="4" class="padding4">
                            {{merge_editable.user.user_pd.current_address2}}
                        </ion-col>

                        <ion-col size="12" sizeMd="4" class="padding4">
                            <app-a-input [label]="'Place of Origin'"
                                [(variable)]="merge_editable.user.user_pd.origin_city"></app-a-input>
                        </ion-col>

                        <ion-col size="12" sizeMd="4" class="padding4">
                            <app-date [label]="'Birth Date'" [(model)]="merge_editable.user.dob"></app-date>
                        </ion-col>

                        <ion-col size="12" sizeMd="4" class="padding4">
                            <app-a-input [label]="'Community'" [disabled]="true"
                                [(variable)]="merge_editable.business_id"></app-a-input>
                        </ion-col>


                        <ion-col size="12" sizeMd="4" class="padding4">
                            <app-a-select [label]="'Blood Group'" [(variable)]="merge_editable.user.user_pd.blood"
                                [objectList]="utilityService.bloodGroupList"></app-a-select>
                        </ion-col>

                        <ion-col size="12" sizeMd="4" class="padding5">
                            <app-date [label]="'Death Date'"
                                [(model)]="merge_editable.user.user_pd.death_date"></app-date>
                        </ion-col>
                    </ion-row>
                </ion-card>
            </ion-col>
            <ion-col size="12" sizeMd="1">

                <ion-button (click)="clickMerge()">
                    <ion-icon name="chevron-back" *ngIf="platform.width()>platform.height()" class="font2"></ion-icon>
                    <ion-icon name="chevron-up" *ngIf="platform.width()<platform.height()" class="font2"></ion-icon>
                    Merge
                </ion-button>
            </ion-col>
            <ion-col size="12" sizeMd="5.5" class="padding0">
                <span class="bold font1_5">Duplicate</span>

                <ion-card>
                    <app-pd-card [emp]="merge_nonEditable" [showImage]="false"></app-pd-card>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-card>
</div>